<div class="app-root">
  <router-outlet>
    <app-loading-spinner *ngIf="isLoading"> </app-loading-spinner>
  </router-outlet>
</div>
